import { SessionFileStatus } from 'entities/ImportSessions/types';
import { PartnersEnum } from 'entities/Partners/enums';

export enum ModelBuildMode {
	template = 'template',
	neural = 'neural',
}

export enum ModelStatuses {
	to_be_trained = 'TO_BE_TRAINED',
	training = 'TRAINING',
	trained = 'TRAINED',
	error = 'ERROR',
}

export enum AutoconnectByLabelsEnum {
	CustomerVatNumber = 'CustomerVatNumber',
	CustomerName = 'CustomerName',
	CustomerAddress = 'CustomerAddress',
	VendorVatNumber = 'VendorVatNumber',
	VendorName = 'VendorName',
	VendorAddress = 'VendorAddress',
}

export interface Settings {
	partnerType?: PartnersEnum;
	autoconnectByLabels?: AutoconnectByLabelsEnum[];
	splitUploadedDoc?: boolean;
	sendEmailOnPartnerAssociationFailure?: boolean;
	sendEmailOnItemCodeNotFound?: boolean;
	sendEmailOnSuccessExport?: boolean;
	sendEmailOnReceiverIdNotFound?: boolean;
	ftpImport?: {
		autoImportInterval?: string;
		path?: string;
		autoImportDeleteAfter?: boolean;
	};
	ftpExport?: {
		autoExportFormat?: string;
		path?: string;
		originalFilePath?: string;
		compressOriginalFile?: boolean;
	};
	pagesRange?: string;
}

export interface GeneralModelSettings {
	name: string;
	settings?: Settings;
}

export type CustomModelType = {
	_id: string;
	customModelId: string;
	uploaderId: string;
	uploadSource: 'DIRECT' | 'FTP';
	fileName: string;
	errorMessage: string;
	host: string;
	filePath: string;
	convertedFilePath: string;
	size: 0;
	createdAt: string;
	updatedAt: string;
};

export interface CustomModelFilesType extends CustomModelType {
	status: SessionFileStatus;
}

export interface ModelsType extends GeneralModelSettings {
	status: ModelStatuses;
	companyId: string;
	createdAt: string;
	createdBy: string;
	recognitionResourceId: string;
	totalFiles: number;
	updatedAt: string;
	_id: string;
	modelBuildMode: ModelBuildMode;
}
